import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { IPublicView, ICreatePublicView } from './public-view.interface'
import { HttpErrorHandlerService } from '../helpers/http-error-handler.service'
import { IUpdateDTModel } from '../helpers/update-model.interface'
import { BehaviorSubject, catchError, filter, finalize, firstValueFrom } from 'rxjs'
import { Observable } from 'rxjs/internal/Observable'
import { API_ENDPOINT_PATH, API_HTTP_HEADERS } from "../helpers/api-constant";

@Injectable({
  providedIn: 'root'
})
export class PublicViewService {
  readonly #headers: HttpHeaders
  readonly #urlEndpoint: string

  private readonly publicViewSubject$: BehaviorSubject<{publicView: IPublicView, event: 'activate'|'update'}> = new BehaviorSubject<{publicView: IPublicView, event: 'activate'|'update'}>({
    publicView: {
      _id: '-1',
      enabled: false,
      name: ''
    },
    event: 'activate'
  })

  private readonly publicView$: Observable<{publicView: IPublicView, event: 'activate'|'update'}> = this.publicViewSubject$.asObservable()
    .pipe(
      filter((data: {publicView: IPublicView, event: 'activate'|'update'})=> data.publicView._id !== '-1'),
      finalize(() => console.log('publicView$ - Observable completed.'))
    )

  constructor(
    private readonly http: HttpClient,
    private readonly errorHandlerService: HttpErrorHandlerService
  ) {
	  this.#urlEndpoint = `${API_ENDPOINT_PATH}/publicView`;
	  this.#headers = new HttpHeaders(API_HTTP_HEADERS);
  }

  private getUrl(): string {
    return `${this.#urlEndpoint}`
  }

  private getHeader(): HttpHeaders {
    return this.#headers
  }

  notifyPublicView(publicView: IPublicView, event: 'activate'|'update'): void {
    this.publicViewSubject$.next({publicView: publicView, event: event})
  }

  observePublicView$(): Observable<{publicView: IPublicView, event: 'activate'|'update'}> {
    return this.publicView$
  }

  async upsertOne(payload: IPublicView | ICreatePublicView): Promise<IPublicView|IUpdateDTModel|{}> {
    const result = this.http.post<IPublicView>(`${this.getUrl()}`, payload,
      { headers: this.getHeader() }).pipe(catchError(this.errorHandlerService.handleErrorForSingleRecord))
    return await firstValueFrom(result)
  }

  async getById(id: string, attr?: string): Promise<IPublicView|{}> {
    let queryUrl = `${this.getUrl()}/${id}`
    if (attr) { queryUrl += `?attr=${attr}`}

    const result = this.http.get<IPublicView>(`${queryUrl}`,
      { headers: this.getHeader() }).pipe(catchError(this.errorHandlerService.handleErrorForSingleRecord))
    return await firstValueFrom(result)
  }

  async listAll(params?: string): Promise<IPublicView[]> {
    let queryUrl = `${this.getUrl()}`
    if (params) { queryUrl += `?${params}` }

    const result = this.http.get<IPublicView[]>(`${queryUrl}`,
      { headers: this.getHeader() }).pipe(catchError(this.errorHandlerService.handleErrorForRecords))
    return await firstValueFrom(result)
  }

  async deleteById(id: string): Promise<IPublicView | null> {
	  const headers = this.getHeader().delete('Content-Type').delete('content-type');

    const result = this.http.delete<IPublicView>(`${this.getUrl()}/${id}`,
      { headers: headers }).pipe(catchError(this.errorHandlerService.handleError))
    return await firstValueFrom(result)
  }
}
